import {

    Alfa

} from '../_Styled';

const Index = (props) => {


    return (<div>


        <Alfa
        backgroundColor={"transparent"}
        height={props.height}
        onClick={(v) => props.handle({

            call:"showProcessMenu",
            data:false,
            calcId:props.data.id

        })}
        ></Alfa>

    </div>)

}

export default Index;


